// extracted by mini-css-extract-plugin
module.exports = {"Body":"NoSelectedSensorsScreen_Body__2_oQs","Icon":"NoSelectedSensorsScreen_Icon__2_cqf","IconContainer":"NoSelectedSensorsScreen_IconContainer__2I0IG"};